"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_1 = require("@material-ui/core/styles");
var useStyles = styles_1.makeStyles(function () {
    return styles_1.createStyles({
        '@keyframes flash': {
            '0%': {
                backgroundColor: 'rgba(255,0,0,0.5)',
            },
            '50%': {
                backgroundColor: 'rgba(255,0,0,0)',
            },
            '100%': {
                backgroundColor: 'rgba(255,0,0,0.5)',
            },
        },
        root: {
            position: 'fixed',
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: 'rgba(255, 0, 0, 0.5)',
            zIndex: 9999999,
            animation: '$flash infinite 0.5s linear',
        },
    });
});
var PomodoroFocusAlertOverlay = function () {
    var classes = useStyles();
    return react_1.default.createElement("div", { className: classes.root });
};
exports.default = PomodoroFocusAlertOverlay;
//# sourceMappingURL=PomodoroFocusAlertOverlay.js.map